import List from "./list/Channels";
import Individual from "./individual/Channel";
import Edit from './edit/EditChannel'

export default { List, Individual, Edit };
